import PropTypes from 'prop-types';
import React from 'react';
import { isMobileOnly } from 'react-device-detect';
import styles from './LocalImageIcon.scss';

const LocalImageIcon = ({ active = false, alt = '', imageName, size = 'lg', title }) => {
  let rootCssClass = styles['local-image-icon'];
  rootCssClass += isMobileOnly ? ` ${styles['mobile']}` : ` ${styles['desktop']}`;
  rootCssClass += ` ${styles[size]}`;
  if (active) rootCssClass += ` ${styles['active']}`;

  return (
    <div className={rootCssClass} title={title}>
      <img alt={alt} aria-hidden="true" src={`/resources/assets/bom/${imageName}.jpg`} />
    </div>
  );
};

LocalImageIcon.propTypes = {
  active: PropTypes.bool,
  alt: PropTypes.string,
  imageName: PropTypes.string.isRequired,
  size: PropTypes.oneOf(['lg', 'sm']),
  title: PropTypes.string,
};

export default LocalImageIcon;
